export default __webpack_public_path__ + "img/7005ad89f2854a05d2d26eb95f42c59f.svg";